// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var JsxRuntime = require("react/jsx-runtime");
var Image$ReactHooksTemplate = require("../common/image.res.js");
var Utils$ReactHooksTemplate = require("../common/utils.res.js");

function SearchForm(props) {
  var handleSearch = props.handleSearch;
  var setSearchKey = props.setSearchKey;
  var searchKey = props.searchKey;
  var handleSearchKeyChange = function ($$event) {
    var searchKey = Utils$ReactHooksTemplate.formTargetValue($$event);
    Curry._1(setSearchKey, (function (param) {
            return searchKey;
          }));
  };
  var tmp;
  tmp = searchKey !== undefined && searchKey !== "" ? JsxRuntime.jsx("button", {
          children: JsxRuntime.jsx("img", {
                className: "w-3 h-3",
                alt: "searchcancelbutton",
                src: Image$ReactHooksTemplate.closeIcon
              }),
          className: "flex-shrink-0 ml-1 focus:outline-none",
          type: "button",
          onClick: (function (param) {
              Curry._1(setSearchKey, (function (param) {
                      
                    }));
            })
        }) : null;
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("form", {
                      children: [
                        JsxRuntime.jsx("button", {
                              children: JsxRuntime.jsx("img", {
                                    className: "h-14-px mr-1 flex-shrink-0",
                                    src: Image$ReactHooksTemplate.searchGray
                                  }),
                              style: {
                                outline: "None"
                              },
                              type: "submit"
                            }),
                        JsxRuntime.jsx("input", {
                              className: "text-sm text-aurometalsaurus w-full min-w-0 pl-2 bg-transparent focus:outline-none",
                              placeholder: props.searchPlaceholder,
                              type: "text",
                              value: Belt_Option.getWithDefault(searchKey, ""),
                              onChange: handleSearchKeyChange
                            })
                      ],
                      className: "flex items-center flex-1 min-w-0",
                      onSubmit: (function ($$event) {
                          $$event.preventDefault();
                          Curry._1(handleSearch, undefined);
                        })
                    }),
                tmp
              ],
              className: "flex items-center w-full min-w-0"
            });
}

var make = SearchForm;

exports.make = make;
/* react/jsx-runtime Not a pure module */
